import { reactive, toRef, watch } from 'vue';
export const useDeleteProxy = props => {
  const {
    deleteRow: deleteRowProp
  } = props || {};
  const deleteRow = toRef(deleteRowProp);
  const deleteConfig = reactive({
    api: '',
    params: null,
    after: null
  });
  watch(() => props.deleteConfig, val => {
    Object.assign(deleteConfig, val);
  }, {
    immediate: true,
    deep: true
  });
  const {
    runAsync: deleteRowFn,
    loading: deleteLoading
  } = fetchApi({
    'getName'() {
      return deleteConfig.api;
    }
  });
  return async ({
    row,
    id
  }) => {
    if (typeof deleteRow.value === 'function') {
      const res = await deleteRow.value({
        row,
        id
      });
      if (!res) return Promise.resolve(false);
      return Promise.resolve(true);
    }
    if (deleteConfig.api) {
      if (deleteLoading.value) return Promise.resolve(false);
      const deleteParams = {};
      if (!!deleteConfig.params && typeof deleteConfig.params === 'function') {
        const tmp = await deleteConfig.params({
          row,
          id
        });
        if (tmp) {
          Object.assign(deleteParams, tmp);
        } else {
          // 返回false,取消删除
          return Promise.resolve(false);
        }
      } else if (!!deleteConfig.params && typeof deleteConfig.params === 'object') {
        Object.assign(deleteParams, deleteConfig.params);
      } else {
        Object.assign(deleteParams, {
          ...row,
          id
        });
      }
      const {
        error
      } = await deleteRowFn(deleteParams);
      if (error) return Promise.resolve(false);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  };
};